import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { format } from 'date-fns';

interface EmspBoTariffUpdatedBeforeFilterStateControllerProps {
  value: Date | string;
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoTariffUpdatedBeforeFilterStateController = ({
  value,
  onRemove,
}: EmspBoTariffUpdatedBeforeFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const updatedAt = format(value, 'yyyy-MM-dd');

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem icon="calendar-date" label={updatedAt} onRemove={onRemove} />
  );
};
